module.exports = __webpack_public_path__ + "img/scotland-logo-icon.375a718b.png";